
// import { ArrowUpIcon } from '@vue-hero-icons/outline';

// const throttle = (callback, limit) => {
//   let waiting = false;
//   return function () {
//     if (!waiting) {
//       callback.apply(this, arguments);
//       waiting = true;
//       setTimeout(() => {
//         waiting = false;
//       }, limit);
//     }
//   };
// };

export default {
  // components: {
  //   ArrowUpIcon,
  // },

  data() {
    return {
      // You need a property to hold the throttled function reference
      // throttledScroll: null,
    };
  },

  // mounted() {
  //   // 1. Create the throttled function and store the reference
  //   this.throttledScroll = throttle(this.onScroll, 100); // Runs once every 100ms
    
  //   // 2. Attach the throttled function to the scroll event
  //   window.addEventListener('scroll', this.throttledScroll);
  // },

  // beforeDestroy() {
  //   // 3. Remove the throttled listener to prevent memory leaks
  //   if (this.throttledScroll) {
  //     window.removeEventListener('scroll', this.throttledScroll);
  //   }
  // },

  methods: {
    // clickScroll() {
    //   window.scrollTo(0, 0);
    // },

    // // This is the function that will now be rate-limited by the throttle utility
    // onScroll(e) {
    //   const goToTopEl = this.$refs.goTop;
    //   const scrollTop = window.scrollY;
    //   scrollTop >= 50
    //     ? goToTopEl.classList.add('pre-show')
    //     : goToTopEl.classList.remove('pre-show');
    // },
  },
};
